import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { autoReactivate } from '../../shared/services/auth/AuthService';
import { useAuth } from '../../shared/contexts/auth/AuthContext';
import { PROJECTS } from '../../shared/routes/path';

const AutoReactivationPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { login } = useAuth();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setError('Invalid reactivation link.');
      return;
    }

    const reactivate = async () => {
      try {
        const tokenData = await autoReactivate(token);
        login(tokenData);
        navigate(PROJECTS);
      } catch {
        setError('This reactivation link is invalid or has already been used. Please contact support.');
      }
    };

    reactivate();
  }, [searchParams]);

  if (error) {
    return (
      <div className="auth-pages">
        <div className="auth-pages__right">
          <div className="form-box">
            <div className="form-box__title">Reactivation failed</div>
            <p>{error}</p>
            <a href="/login">Back to login</a>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-pages">
      <div className="auth-pages__right">
        <div className="form-box">
          <div className="form-box__title">Reactivating your account...</div>
          <p>Please wait while we restore your account.</p>
        </div>
      </div>
    </div>
  );
};

export default AutoReactivationPage;
